import { render, staticRenderFns } from "./CamstudyDeviceSetting.vue?vue&type=template&id=0fa174a4&scoped=true&"
import script from "./CamstudyDeviceSetting.vue?vue&type=script&lang=js&"
export * from "./CamstudyDeviceSetting.vue?vue&type=script&lang=js&"
import style0 from "./CamstudyDeviceSetting.vue?vue&type=style&index=0&id=0fa174a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa174a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fa174a4')) {
      api.createRecord('0fa174a4', component.options)
    } else {
      api.reload('0fa174a4', component.options)
    }
    module.hot.accept("./CamstudyDeviceSetting.vue?vue&type=template&id=0fa174a4&scoped=true&", function () {
      api.rerender('0fa174a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/DeviceSetting/coordi/CamstudyDeviceSetting.vue"
export default component.exports